import React from 'react'
import styles from './Pagination.module.scss'
import cn from 'classnames'

const PaginationButton = ({ value, isCurrentPage, onPageButtonClick }) => {
  return (
    <div
      className={cn(
        styles.paginationButton,
        isCurrentPage ? styles.currentButton : styles.defaultButton,
      )}
      onClick={() => {
        if (!isCurrentPage) onPageButtonClick(value)
      }}
    >
      {value}
    </div>
  )
}

export default function Pagination({
  pages,
  currentPage,
  firstPage,
  lastPage,
  onPageButtonClick,
  onPrevButtonClick,
  onNextButtonClick,
}) {
  return (
    <div className={styles.pagination}>
      {firstPage !== 1 && (
        <>
          <div className={styles.prevButton} onClick={onPrevButtonClick}>
            <img src="/search/arrow-left-black.svg" alt="black left arrow" />
          </div>
          <div className={styles.paginationButton} onClick={onPrevButtonClick}>
            ...
          </div>
        </>
      )}

      {new Array(lastPage - firstPage + 1).fill().map((_e, i) => (
        <PaginationButton
          key={i}
          onPageButtonClick={onPageButtonClick}
          value={firstPage + i}
          isCurrentPage={firstPage + i === currentPage}
        />
      ))}

      {lastPage !== pages && (
        <>
          <div className={styles.paginationButton} onClick={onNextButtonClick}>
            ...
          </div>
          <div className={styles.nextButton} onClick={onNextButtonClick}>
            <img src="/search/arrow-right-black.svg" alt="black right arrow" />
          </div>
        </>
      )}
    </div>
  )
}
